import { L_latLng, } from '../leaflet/leaflet-util';
import { _coord2s, _s2coord, _coordPrecision, } from '../service/coord-encoding';
const _dataSep = ',', _routeSep = '+', _countBase = 36, _singleDigitCountSymbol = '.', _countStartSymbol = '(', _countEndSymbol = ')', _coordCountSymbol = '*', _latLngs2s = (latLngSeqs) => latLngSeqs.map(_singlePolylineLatLngs2s).join(_routeSep), _singlePolylineLatLngs2s = (latLngs) => {
    const lats = _lats(latLngs), lngs = _lngs(latLngs), latsEnc = _encode(lats), lngsEnc = _encode(lngs), coordCount = latLngs.length, countStr = coordCount.toString(_countBase);
    return countStr + _dataSep + latsEnc + lngsEnc;
}, _lat = (latLng) => latLng.lat, _lats = (latLngs) => latLngs.map(_lat), _lng = (latLng) => latLng.lng, _lngs = (latLngs) => latLngs.map(_lng), _encode = (coords) => {
    const coordStrs = coords.map(_coord2s), coordCount = coords.length, transposedStr = _transposeCoordStrs(coordStrs);
    return _compress(transposedStr, coordCount);
}, _transposeCoordStrs = (coordStrs) => {
    let transposedStr = '';
    for (let i = 0; i < _coordPrecision; ++i) {
        transposedStr += coordStrs.map(_charAt(i)).join('');
    }
    return transposedStr;
}, _charAt = (i) => (str) => str.charAt(i), _compress = (transposedStr, coordCount) => {
    const transposedStrLen = transposedStr.length;
    if (transposedStrLen === 0) {
        return '';
    }
    let compressedStr = '', repeatCount = 1, repeatedChar = transposedStr[0];
    for (let i = 1; i <= transposedStrLen; ++i) {
        const isRepeat = (i < transposedStrLen &&
            transposedStr[i] === repeatedChar);
        if (isRepeat) {
            ++repeatCount;
        }
        else {
            if (repeatCount === 1) {
                compressedStr += repeatedChar;
            }
            else if (repeatCount === 2) {
                compressedStr += repeatedChar + repeatedChar;
            }
            else if (repeatCount === coordCount) {
                compressedStr += _coordCountSymbol + repeatedChar;
            }
            else {
                const countStr = repeatCount.toString(_countBase), addedStr = (countStr.length <= 1 ?
                    _singleDigitCountSymbol + countStr + repeatedChar :
                    _countStartSymbol + countStr + _countEndSymbol + repeatedChar);
                compressedStr += addedStr;
            }
            repeatedChar = transposedStr[i];
            repeatCount = 1;
        }
    }
    return compressedStr;
}, _s2latLngs = (s) => {
    return s ? s.split(_routeSep).map(_s2singlePolylineLatLngs) : [];
}, _s2singlePolylineLatLngs = (coordsStr) => {
    const [countStr, encodedLatLngs] = coordsStr.split(_dataSep), coordCount = parseInt(countStr, _countBase), [lats, lngs] = _decode(encodedLatLngs, coordCount), latLngs = [];
    for (let i = 0; i < coordCount; ++i) {
        const latLng = L_latLng(lats[i], lngs[i]);
        latLngs.push(latLng);
    }
    return latLngs;
}, _decode = (encodedLatLngs, coordCount) => {
    const decompressedStr = _decompress(encodedLatLngs, coordCount), coordStrArrays = _longStrToCoordStrArrays(decompressedStr), coordArrays = coordStrArrays.map(_strArray2coord);
    return coordArrays;
}, _strArray2coord = (arr) => arr.map(_s2coord), _decompress = (compressedStr, coordCount) => {
    let decompressedStr = '', countStr = '', parseState = _ps_standard;
    for (const ch of compressedStr) {
        switch (ch) {
            case _coordCountSymbol:
                parseState = _ps_hasCoordCountRepeat;
                break;
            case _singleDigitCountSymbol:
                parseState = _ps_singleDigitCount;
                break;
            case _countStartSymbol:
                parseState = _ps_multiDigitCount;
                break;
            case _countEndSymbol:
                parseState = _ps_hasRepeat;
                break;
            default:
                switch (parseState) {
                    case _ps_singleDigitCount:
                        countStr = ch;
                        parseState = _ps_hasRepeat;
                        break;
                    case _ps_multiDigitCount:
                        countStr += ch;
                        break;
                    case _ps_hasRepeat:
                    case _ps_hasCoordCountRepeat:
                        const repeatCount = (parseState === _ps_hasCoordCountRepeat ?
                            coordCount : parseInt(countStr, _countBase));
                        decompressedStr += ch.repeat(repeatCount);
                        countStr = '';
                        parseState = _ps_standard;
                        break;
                    default:
                        decompressedStr += ch;
                }
        }
    }
    return decompressedStr;
}, _ps_standard = 0, _ps_singleDigitCount = 1, _ps_multiDigitCount = 2, _ps_hasRepeat = 3, _ps_hasCoordCountRepeat = 4, _longStrToCoordStrArrays = (decompressedStr) => {
    const charCount = decompressedStr.length / 2, coordStrCount = charCount / _coordPrecision;
    const latStrs = _longStrToCoordStrArray(decompressedStr, charCount, coordStrCount, 0), lngStrs = _longStrToCoordStrArray(decompressedStr, charCount, coordStrCount, charCount), strArrays = [latStrs, lngStrs];
    return strArrays;
}, _longStrToCoordStrArray = (decompressedStr, charCount, coordStrCount, startIndex) => {
    const strArray = Array(coordStrCount);
    strArray.fill('');
    for (let i = startIndex; i < startIndex + charCount; ++i) {
        const strArrayIndex = (i - startIndex) % coordStrCount;
        strArray[strArrayIndex] += decompressedStr[i];
    }
    return strArray;
};
export { _latLngs2s, _s2latLngs, };
